import React from 'react'
import cn from 'classnames'

interface BackdropProps {
  kind: 'dark' | 'extra-dark'
  children?: React.ReactElement
  className: string
}

const Backdrop = ({ className, children, kind }: BackdropProps) => {
  const classes = cn({
    'mc-backdrop': true,
    [`mc-backdrop--${kind}`]: kind,
    [className]: className,
  })

  return <div className={classes}>{children}</div>
}

export default Backdrop
